var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM12.7109 13.364C12.7349 13.292 12.871 13.0191 13.603 12.5291C14.783 11.7381 15.311 10.6079 15.092 9.34595C14.87 8.07095 13.8309 7.02403 12.5649 6.80103C11.6399 6.63703 10.703 6.88593 9.99097 7.48193C9.27197 8.08493 8.86011 8.96989 8.86011 9.91089C8.86011 10.3249 9.19611 10.6609 9.61011 10.6609C10.0241 10.6609 10.3601 10.3249 10.3601 9.91089C10.3601 9.41489 10.5771 8.9481 10.9551 8.6311C11.3311 8.3161 11.811 8.1871 12.304 8.2771C12.95 8.3911 13.501 8.94805 13.615 9.60205C13.658 9.84905 13.7891 10.599 12.7681 11.282C11.9411 11.837 11.471 12.346 11.29 12.886C11.158 13.279 11.3699 13.7039 11.7629 13.8359C11.8419 13.8629 11.922 13.875 12.001 13.875C12.313 13.875 12.6049 13.677 12.7109 13.364ZM13.02 16.5C13.02 15.948 12.573 15.5 12.02 15.5H12.01C11.458 15.5 11.0149 15.948 11.0149 16.5C11.0149 17.052 11.468 17.5 12.02 17.5C12.572 17.5 13.02 17.052 13.02 16.5Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.5f506cdb279d3bc5915a4db228a08a1d.svg";
export { ForwardRef as ReactComponent };